// extracted by mini-css-extract-plugin
export var iconWrapper = "person-module--icon-wrapper--ac378";
export var image = "person-module--image--1a942";
export var infoWrapper = "person-module--info-wrapper--1362b";
export var nameText = "person-module--name-text--b03e4";
export var wrapper = "person-module--wrapper--c45b1";